import React, { useEffect, useMemo, useState } from "react";
import FiltroMultiple from "../../../Postventa/Dashboard/Modales/FiltroMultiple";

const ESTADO_VACIO_FILTROS = {
  asesor: [],
  razonSocial: [],
  sucursal: [],
  ubicacion: [],
  localidad: [],
  municipio: [],
  estado: [],
  geolocalizacion: [],
};
const ESTADO_VACIO_MOSTRAR = {
  asesor: { open: false },
  razonSocial: { open: false },
  sucursal: { open: false },
  ubicacion: { open: false },
  localidad: { open: false },
  municipio: { open: false },
  estado: { open: false },
  geolocalizacion: { open: false },
};

const textoGeo = (v) => (v === 1 || v === "1" ? "Sí" : "No");

// Tabla agrupada por asesor — mismo patrón que ReporteClientesTabla (Información Capturada).
// "listado" llega plano desde ReportesCRM/ReporteGeolocalizacion — cada fila es un cliente con
// idcliente, razon_social, idvendedor, vendedor, IDSucursal, sucursal, geolocalizacion,
// ubicacion, idlocalidad, localidad, idmunicipio, municipio, idestado, estado (no se muestran
// los ids).
export const ReporteGeolocalizacionTabla = ({ listado: listadoProp }) => {
  const listado = Array.isArray(listadoProp) ? listadoProp : [];
  const [options, setOptions] = useState(ESTADO_VACIO_FILTROS);
  const [filtros, setFiltros] = useState(ESTADO_VACIO_FILTROS);
  const [filtrosTemp, setFiltrosTemp] = useState(ESTADO_VACIO_FILTROS);
  const [mostrarFiltro, setMostrarFiltro] = useState(ESTADO_VACIO_MOSTRAR);
  const [prioridadFiltros, setPrioridadFiltros] = useState([]);
  const [abiertos, setAbiertos] = useState({});

  const onToggle = (idvendedor) => {
    setAbiertos((prev) => ({ ...prev, [idvendedor]: !prev[idvendedor] }));
  };

  useEffect(() => {
    setOptions({
      asesor: [...new Set(listado.map((c) => c.vendedor).filter(Boolean))].map((v) => ({ value: v, label: v })),
      razonSocial: [...new Set(listado.map((c) => c.razon_social).filter(Boolean))].map((v) => ({ value: v, label: v })),
      sucursal: [...new Set(listado.map((c) => c.sucursal).filter(Boolean))].map((v) => ({ value: v, label: v })),
      ubicacion: [...new Set(listado.map((c) => c.ubicacion).filter(Boolean))].map((v) => ({ value: v, label: v })),
      localidad: [...new Set(listado.map((c) => c.localidad).filter(Boolean))].map((v) => ({ value: v, label: v })),
      municipio: [...new Set(listado.map((c) => c.municipio).filter(Boolean))].map((v) => ({ value: v, label: v })),
      estado: [...new Set(listado.map((c) => c.estado).filter(Boolean))].map((v) => ({ value: v, label: v })),
      geolocalizacion: [0, 1].map((v) => ({ value: v, label: textoGeo(v) })),
    });
  }, [listado]);

  const actualizarPrioridad = (filtro) => {
    setPrioridadFiltros((prev) => {
      const index = prev.indexOf(filtro);
      const nuevasPrioridades = index === -1 ? [...prev, filtro] : prev.slice(0, index + 1);

      setFiltrosTemp((prevTemp) => {
        const limpio = { ...prevTemp };
        Object.keys(limpio).forEach((key) => {
          if (!nuevasPrioridades.includes(key)) limpio[key] = [];
        });
        return limpio;
      });

      setFiltros((prevFiltros) => {
        const limpio = { ...prevFiltros };
        Object.keys(limpio).forEach((key) => {
          if (!nuevasPrioridades.includes(key)) limpio[key] = [];
        });
        return limpio;
      });

      return nuevasPrioridades;
    });
  };

  const asesoresAgrupados = useMemo(() => {
    let data = [...listado];

    prioridadFiltros.forEach((filtro) => {
      if (filtro === "asesor" && filtros.asesor.length > 0) {
        data = data.filter((c) => filtros.asesor.includes(c.vendedor));
      }
      if (filtro === "razonSocial" && filtros.razonSocial.length > 0) {
        data = data.filter((c) => filtros.razonSocial.includes(c.razon_social));
      }
      if (filtro === "sucursal" && filtros.sucursal.length > 0) {
        data = data.filter((c) => filtros.sucursal.includes(c.sucursal));
      }
      if (filtro === "ubicacion" && filtros.ubicacion.length > 0) {
        data = data.filter((c) => filtros.ubicacion.includes(c.ubicacion));
      }
      if (filtro === "localidad" && filtros.localidad.length > 0) {
        data = data.filter((c) => filtros.localidad.includes(c.localidad));
      }
      if (filtro === "municipio" && filtros.municipio.length > 0) {
        data = data.filter((c) => filtros.municipio.includes(c.municipio));
      }
      if (filtro === "estado" && filtros.estado.length > 0) {
        data = data.filter((c) => filtros.estado.includes(c.estado));
      }
      if (filtro === "geolocalizacion" && filtros.geolocalizacion.length > 0) {
        data = data.filter((c) => filtros.geolocalizacion.includes(c.geolocalizacion));
      }
    });

    const grupos = new Map();
    data.forEach((c) => {
      if (!grupos.has(c.idvendedor)) {
        grupos.set(c.idvendedor, {
          idvendedor: c.idvendedor,
          vendedor: c.vendedor,
          sucursal: c.sucursal,
          clientes: [],
          geolocalizados: 0,
        });
      }
      const grupo = grupos.get(c.idvendedor);
      grupo.clientes.push(c);
      if (c.geolocalizacion === 1 || c.geolocalizacion === "1") grupo.geolocalizados += 1;
    });

    // idvendedor -1 y 0 (sin asesor asignado) siempre al final, después de los asesores reales
    const esSinAsesor = (idvendedor) => idvendedor === -1 || idvendedor === 0;
    return [...grupos.values()].sort((a, b) => {
      const aSinAsesor = esSinAsesor(a.idvendedor);
      const bSinAsesor = esSinAsesor(b.idvendedor);
      if (aSinAsesor !== bSinAsesor) return aSinAsesor ? 1 : -1;
      return (a.vendedor || "").localeCompare(b.vendedor || "", "es");
    });
  }, [listado, filtros, prioridadFiltros]);

  const totalClientes = asesoresAgrupados.reduce((acc, a) => acc + a.clientes.length, 0);
  const totalGeolocalizados = asesoresAgrupados.reduce((acc, a) => acc + a.geolocalizados, 0);

  const filtroProps = (field, label) => ({
    label,
    field,
    options: options[field],
    filtros,
    setFiltros,
    filtrosTemp,
    setFiltrosTemp,
    mostrarFiltro,
    setMostrarFiltro,
    actualizarPrioridad,
    setPrioridadFiltros,
  });

  return (
    <div className="crmcs-cot-tabla-wrap">
      <div className="crmcs-cot-tabla-scroll scroll">
        <table cellPadding={0} cellSpacing={0}>
          <thead>
            <tr>
              <th>
                <div>
                  <FiltroMultiple {...filtroProps("asesor", "Asesor")} />
                </div>
              </th>
              <th>
                <div className="borde-izq">
                  <FiltroMultiple {...filtroProps("razonSocial", "Cliente")} />
                </div>
              </th>
              <th>
                <div className="borde-izq">
                  <FiltroMultiple {...filtroProps("sucursal", "Sucursal")} />
                </div>
              </th>
              <th>
                <div className="borde-izq">
                  <FiltroMultiple {...filtroProps("localidad", "Localidad")} />
                </div>
              </th>
              <th>
                <div className="borde-izq">
                  <FiltroMultiple {...filtroProps("municipio", "Municipio")} />
                </div>
              </th>
              <th>
                <div className="borde-izq">
                  <FiltroMultiple {...filtroProps("estado", "Estado")} />
                </div>
              </th>
              <th>
                <div className="borde-izq">
                  <FiltroMultiple {...filtroProps("ubicacion", "Google Maps")} />
                </div>
              </th>
              <th>
                <div className="borde-izq">
                  <FiltroMultiple {...filtroProps("geolocalizacion", "Geolocalización")} />
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {asesoresAgrupados.map((asesor) => {
              const expandido = !!abiertos[asesor.idvendedor];
              return (
                <React.Fragment key={asesor.idvendedor}>
                  <tr className="rca-row-asesor" onClick={() => onToggle(asesor.idvendedor)}>
                    <td className="rca-td-asesor">
                      <span className="rca-flecha">{expandido ? "▼" : "▶"}</span>
                      <strong>{asesor.vendedor}</strong>
                      {asesor.idvendedor !== -1 && asesor.idvendedor !== 0 && (
                        <span className="rca-td-asesor-sucursal">{asesor.sucursal}</span>
                      )}
                    </td>
                    <td colSpan={5}></td>
                    <td className="rca-td-contador" colSpan={2}>
                      {asesor.geolocalizados}/{asesor.clientes.length} geolocalizados
                    </td>
                  </tr>

                  {expandido && asesor.clientes.map((c) => (
                    <tr key={c.idcliente} className="rca-row-cliente">
                      <td></td>
                      <td className="rca-td-cliente">{c.razon_social}</td>
                      <td>{c.sucursal || "—"}</td>
                      <td>{c.localidad || "—"}</td>
                      <td>{c.municipio || "—"}</td>
                      <td>{c.estado || "—"}</td>
                      <td>{c.ubicacion || "—"}</td>
                      <td>
                        <span className={`rca-verificado-pill ${c.geolocalizacion === 1 || c.geolocalizacion === "1" ? "si" : "no"}`}>
                          {textoGeo(c.geolocalizacion)}
                        </span>
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="crmcs-cot-tabla-total">
        <span>Total ({asesoresAgrupados.length} asesores)</span>
        <span>{totalGeolocalizados}/{totalClientes} geolocalizados</span>
      </div>
    </div>
  );
};
